import { BreadcrumbItem, BreadcrumbLink, Text, Icon } from "@chakra-ui/react";
import { FiChevronRight } from "react-icons/fi";
import Link from "next/link"; //isCurrentPage
type BreadcrumbItemsProps = {
  current?: boolean;
  link: string;
  name: string;
};
export function BreadcrumbItems({ current, link, name }: BreadcrumbItemsProps) {
  return (
    <BreadcrumbItem isCurrentPage={current}>
      <BreadcrumbLink as={current ? null : Link} href={`/${link}`}>
        <Text fontWeight="bold" fontSize="lg">
          {name}
          <Icon as={FiChevronRight} color="gray.500" />
        </Text>
      </BreadcrumbLink>
    </BreadcrumbItem>
  );
}
